(() => {
  if (customElements.get('atwill-shorts-offer')) return;
  class ShortsOffer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-offer-data]').textContent);
      this.color = this.querySelector('[data-offer-color]');
      this.size = this.querySelector('[data-offer-size]');
      this.variantSelect = this.querySelector('[data-offer-variant]');
      this.button = this.querySelector('[data-offer-add]');
      this.error = this.querySelector('[data-offer-error]');
      this.addEventListener('change', () => this.update());
      this.button.addEventListener('click', event => this.add(event));
      this.querySelector('[data-offer-guide]').addEventListener('click', event => {
        const chart = this.querySelector('atwill-size-chart');
        chart?.highlight(this.size?.value);
        chart?.open(event.currentTarget);
      });
      this.update();
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100);
    }
    update() {
      const variants = this.config.variants;
      const ci = Number(this.dataset.colorIndex);
      const si = Number(this.dataset.sizeIndex);
      if (this.color && this.size) {
        [...this.size.options].forEach(option => {
          if (!option.value) return;
          option.disabled = !variants.some(v => v.available && v.options[ci] === this.color.value && v.options[si] === option.value);
          option.textContent = option.value + (option.disabled ? ` — ${this.config.messages.soldOut}` : '');
        });
        if (this.size.selectedOptions[0]?.disabled) this.size.value = '';
        this.variant = variants.find(v => v.options[ci] === this.color.value && v.options[si] === this.size.value);
      } else {
        this.variant = variants.find(v => String(v.id) === this.variantSelect?.value);
      }
      const displayed = this.variant || variants.find(v => v.available && (!this.color || v.options[ci] === this.color.value));
      const imageVariant = displayed || variants.find(v => !this.color || v.options[ci] === this.color.value);
      const img = this.querySelector('.aw-offer-image img');
      if (img) {
        img.removeAttribute('srcset');
        if (imageVariant?.image) { img.src = imageVariant.image; img.hidden = false; }
        else { img.removeAttribute('src'); img.hidden = true; }
      }
      this.button.disabled = this.busy || !this.variant?.available;
      if (displayed) {
        const price = this.money(Math.max(0, displayed.price - Number(this.dataset.saving)));
        this.querySelector('[data-offer-price]').textContent = price;
        this.querySelector('[data-offer-original]').textContent = this.money(displayed.price);
        this.button.textContent = this.config.messages.add.replace('__PRICE__', price).replace('__SAVING__', this.money(Number(this.dataset.saving)));
      }
      this.error.textContent = '';
    }
    async add(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || !this.variant?.available) return;
      const root = window.Shopify?.routes?.root || '/';
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.error.textContent = '';
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: this.variant.id, quantity: 1}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.config.messages.error);
        added = true;
        const cartResponse = await fetch(`${root}cart.js`, {headers: {Accept: 'application/json'}});
        if (!cartResponse.ok) throw new Error(this.config.messages.error);
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('product:add-to-cart:success', {detail: {cart, line_item: result}}));
        const drawer = window.Core?.Components?.getComponent('cart-drawer');
        const onCartPage = location.pathname.replace(/\/$/, '') === `${root}cart`.replace(/\/$/, '');
        if (drawer?.enabled && !onCartPage) {
          const trigger = document.querySelector('[data-header-cart-count]')?.closest('a') || this.button;
          await drawer.open(trigger, true, result.items);
        } else location.assign(`${root}cart`);
      } catch (problem) {
        if (added) { location.assign(`${root}cart`); return; }
        this.error.textContent = problem.message || this.config.messages.error;
      } finally {
        this.busy = false;
        this.button.disabled = !this.variant?.available;
        this.button.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('atwill-shorts-offer', ShortsOffer);
})();
